/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.6.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function ReadingFromJSON(json) {
    return ReadingFromJSONTyped(json, false);
}
export function ReadingFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fmRecordId': !exists(json, 'fmRecordId') ? undefined : json['fmRecordId'],
        'fmModId': !exists(json, 'fmModId') ? undefined : json['fmModId'],
        'readingID': !exists(json, 'readingID') ? undefined : json['readingID'],
        'meterID': !exists(json, 'meterID') ? undefined : json['meterID'],
        'assetID': !exists(json, 'assetID') ? undefined : json['assetID'],
        'readingWKTskCreationID': !exists(json, 'readingWKTskCreationID') ? undefined : json['readingWKTskCreationID'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'date': !exists(json, 'date') ? undefined : (json['date'] === null ? null : new Date(json['date'])),
        'currentReading': !exists(json, 'currentReading') ? undefined : json['currentReading'],
        'previousReading': !exists(json, 'previousReading') ? undefined : json['previousReading'],
        'wkordNum': !exists(json, 'wkordNum') ? undefined : json['wkordNum'],
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
        'cMeterDifference': !exists(json, 'cMeterDifference') ? undefined : json['cMeterDifference'],
    };
}
export function ReadingToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fmRecordId': value.fmRecordId,
        'fmModId': value.fmModId,
        'readingID': value.readingID,
        'meterID': value.meterID,
        'assetID': value.assetID,
        'readingWKTskCreationID': value.readingWKTskCreationID,
        'name': value.name,
        'date': value.date === undefined ? undefined : (value.date === null ? null : value.date.toISOString()),
        'currentReading': value.currentReading,
        'previousReading': value.previousReading,
        'wkordNum': value.wkordNum,
        'notes': value.notes,
        'cMeterDifference': value.cMeterDifference,
    };
}
